import { TestStatus } from "types/tests";

export function getVirtualPageForTestStatus(status: TestStatus): string | null {
  switch (status) {
    case TestStatus.DeviceSelection:
    case TestStatus.PatientSelection:
      return "/new-test/patient-selection";

    case TestStatus.TestConfiguration:
      return "/new-test/configuration";

    case TestStatus.StartRequested:
    case TestStatus.TerminateRequested:
      return "/new-test/transition";

    case TestStatus.VirtualAssistant:
    case TestStatus.Started:
    case TestStatus.Completed:
    case TestStatus.WaitingForNextEye:
    case TestStatus.Paused:
    case TestStatus.CompleteRequested:
      return "/new-test/progress";

    default:
      return null;
  }
}
